'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  learnMore: 'LEARN_MORE',
  selectProvider: 'SELECT_PROVIDER',
  closeAlert: 'CLOSE_ALERT',
  chooseProvider: 'CHOOSE_PROVIDER',
  providerSuccessfullyChanged: 'PROVIDER_SUCCESSFULLY_CHANGED',
  compareProviders: 'COMPARE_PROVIDERS',
  close: 'CLOSE',
  setSelectedProvider: 'SET_SELECTED_PROVIDER',
  openSupportDialog: 'OPEN_SUPPORT_DIALOG',
  closeSupportDialog: 'CLOSE_SUPPORT_DIALOG',
  openHelp: 'OPEN_HELP',
  closeHelp: 'CLOSE_HELP',
  setAlert: 'SET_ALERT'
};